import React, { Component } from "react"
import { Popover, PopoverBody } from "reactstrap"

import BackgroundImage from "./BackgroundImage"

class ImageSelector extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isPopoverOpen: false
        }
        this.togglePopover = this.togglePopover.bind(this)
        this.openFileSelector = this.openFileSelector.bind(this)
        this.onFileSelect = this.onFileSelect.bind(this)
        this.onImageRemove = this.onImageRemove.bind(this)
    }

    togglePopover() {
        this.setState({
            isPopoverOpen: !this.state.isPopoverOpen
        })
    }

    openFileSelector() {
        this.fileElement.click()
    }

    onFileSelect() {
        if (this.fileElement.files)
            this.props.onImageSelect(this.fileElement.files[0])
    }

    onImageRemove() {
        this.togglePopover()
        this.props.onImageSelect(null)
    }

    render() {
        const classList = ["image-preview", "item-background-image"].concat(
            this.props.classList || []
        )
        return (
            <BackgroundImage
                imageUrl={this.props.imageUrl}
                classList={classList}
            >
                <div className="dropdown">
                    <span
                        className="icon icon-upload-image"
                        id="image-menu"
                        onClick={this.togglePopover}
                    />
                    <Popover
                        placement="bottom"
                        isOpen={this.state.isPopoverOpen}
                        target="image-menu"
                        toggle={this.togglePopover}
                        trigger="legacy"
                    >
                        <PopoverBody>
                            <ul
                                className="list-group"
                                aria-labelledby="image-menu"
                            >
                                <li
                                    className="list-group-item"
                                    onClick={this.openFileSelector}
                                >
                                    Upload image
                                </li>
                                <li
                                    style={{ display: "inline" }}
                                    role="separator"
                                >
                                    <hr />
                                </li>
                                <li
                                    className="list-group-item"
                                    onClick={this.onImageRemove}
                                >
                                    Remove
                                </li>
                            </ul>
                        </PopoverBody>
                    </Popover>
                </div>
                <input
                    type="file"
                    ref={fileElement => (this.fileElement = fileElement)}
                    onChange={this.onFileSelect}
                    style={{ display: "none" }}
                    accept="image/*"
                />
            </BackgroundImage>
        )
    }
}

export default ImageSelector
